<div class="heroContainer">
  <c-carousel transition="crossfade" [interval]="10000" [pause]="false">
    <!-- <c-carousel-indicators></c-carousel-indicators> -->
    <c-carousel-inner class="w-100 h-100">
      <c-carousel-item class="w-100 h-100">
        <!-- Panel IFP -->
        <div>
          <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
          <div class="position-relative w-100 overflow-hidden">
            <img src="	https://d3uop73ba1wtqg.cloudfront.net/uploads/mSTXOtkDQnaWJGJUnbtNdLw8rqAsXYH4soVUszik.gif"
              alt="Virsa digital classroom solution" class="img-fluid w-100 d-block" />
            <div
              class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center text-start px-3 px-md-5">

              <div class="position-absolute top-0 end-0 p-4 d-none d-md-flex flex-column align-items-end"
                style="z-index: 10;">
                <div class="d-flex align-items-center">
                  <span class="text-white fw-bold me-2" style="font-size: 1.2rem;">Available on GeM</span>
                  <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/b0mws1L10bZSZkgirK7oeBkSn7TtensXW6nFiA0T.png"
                    alt="GeM - Government e Marketplace Logo" style="height: 4.5rem; width: auto;" />
                </div>
                <div class="text-white fw-bold" style="font-size: 1rem; text-shadow: 0 2px 4px rgba(0,0,0,0.8);">GeM
                  Quality Star Rating: <span style="color: #FFD700; font-size: 1.4rem;">★★★★★</span></div>
              </div>

              <div class="d-none d-md-block card-section" style="width: 35%;">
                <div class="d-flex align-items-center mb-5">
                  <span class="text-white fw-bold me-2" style="font-size: 1rem;">EDLA Certified</span>
                  <img src="assets/images/home/edla.png" alt="Google EDLA Certification Logo" style="height: 2rem; width: auto" />
                </div>
                <h1 class="headingBL title mb-3" style="font-size: 34px;">
                  Virsa – Smart Classroom & <br /><span>Digital Learning Solutions</span>
                </h1>
                <div class="w-100 d-flex flex-row">
                  <p class="text-white fs-6 fs-md-5 w-100 vtext">
                    India’s fastest-growing solution provider for digitization in the education sector.
                  </p>
                </div>
                <div class="justify-content-center">
                  <button class="btnGlobal--primary heroBtn" style="margin-right: 0.2em;" (click)="openDemoBooking()">
                    Schedule a Demo
                  </button>
                  <!-- <button class="btnGlobal--secondary heroBtn" style="margin-left: 0.2em;"
                    (click)="downloadCatalogue()">
                    Download Catalogue
                  </button> -->
                </div>
              </div>
            </div>
          </div>
          <div class="d-block d-md-none text-center mobile-hero-content">
            <!-- Mobile Certifications -->
            <div class="d-flex flex-wrap justify-content-center align-items-center mb-3 gap-2 px-2">
              <div class="d-flex align-items-center">
                <span class="text-dark fw-bold me-2" style="font-size: 0.85rem;">EDLA Certified</span>
                <img src="assets/images/home/edla.png" alt="Google EDLA Certification Logo" style="height: 1.5rem; width: auto" />
              </div>
              <span class="text-dark mx-2" style="font-size: 0.85rem;">|</span>
              <div class="d-flex align-items-center">
                <span class="text-dark fw-bold me-2" style="font-size: 0.85rem;">Available on GeM</span>
                <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/b0mws1L10bZSZkgirK7oeBkSn7TtensXW6nFiA0T.png"
                  alt="GeM - Government e Marketplace Logo" style="height: 1.5rem; width: auto" />
              </div>
            </div>

            <h1 class="headingBL title mb-3" style="font-size: 1.75rem;">
              Virsa – Smart Classroom & <br /><span>Digital Learning Solutions</span>
            </h1>
            <div class="w-100 d-flex justify-content-center px-3">
              <p class="text-dark fs-6 w-100 vtext" style="max-width: 400px;">
                India's fastest-growing solution provider for digitization in the education sector.
              </p>
            </div>
            <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 px-3 mb-3">
              <button class="btnGlobal--primary heroBtn mobile-hero-btn" (click)="openDemoBooking()">
                Schedule a Demo
              </button>
              <!-- <button class="btnGlobal--secondary heroBtn mobile-hero-btn" (click)="downloadCatalogue()">
                Download Catalogue
              </button> -->
            </div>
          </div>
        </div>
      </c-carousel-item>

    </c-carousel-inner>
    <!-- <c-carousel-control [routerLink] caption="Previous" direction="prev" />
    <c-carousel-control [routerLink] caption="Next" direction="next" /> -->
  </c-carousel>

  <!-- Logo Slider Section -->
  <div class="logo-slider-container">
    <div class="logo-track">
      <!-- First Copy -->
      <div class="logo-slide" *ngFor="let logo of logos">
        <img [src]="logo.src" [alt]="logo.alt" />
      </div>
      <!-- Second Copy for Seamless Loop -->
      <div class="logo-slide" *ngFor="let logo of logos">
        <img [src]="logo.src" [alt]="logo.alt" />
      </div>
    </div>
  </div>
</div>